import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseService } from './base.service';
import {
  BasePageResponse,
  PolicyDocumentResponse,
  PostIptalResponse,
  ReporDefinitionResponse,
  RunningReportResponse
} from '../model/Response';
import {OrderSearchRequest, UpdateHistRequest, UpdateOrderRequest, ApprovePhotoRequest, ChangePolicyRequest,ClaimRequet,ReportRequest} from '../model/Request';
import { FileUploadRequest } from '../model/dealer';

@Injectable({providedIn: 'root'})
export class OrderService extends BaseService {

  private orderBasePath = '/web/v1/order';
  private claimBasePath = '/web/v1/claims';
  private reportBasePath = '/web/v1/report';
  constructor(private http: HttpClient) {
      super(http);
  }

  searchOrder(request: OrderSearchRequest): Observable<BasePageResponse> {
      return this.post<BasePageResponse, OrderSearchRequest>(this.orderBasePath, request);
  }

  getOrder(orderNumber, packageId): Observable<BasePageResponse> {
    return this.get<BasePageResponse>(this.orderBasePath + '/' + orderNumber + '/' + packageId);
  }

  updateOrder(request: UpdateOrderRequest): Observable<any> {
    return this.put<any, UpdateOrderRequest>(this.orderBasePath, request);
  }

  getPolicyDocument(insurenceCompany, policyRef): Observable<PolicyDocumentResponse> {
    return this.get<PolicyDocumentResponse>('/web/v1/policy/document/' + insurenceCompany + '/' + policyRef);
  }

  getCancelPolicyDocument(insurenceCompany, policyRef): Observable<PolicyDocumentResponse> {
    return this.get<PolicyDocumentResponse>('/web/v1/policy/cancedocument/' + insurenceCompany + '/' + policyRef);
  }

  getReport(request: OrderSearchRequest) : Observable<PolicyDocumentResponse>{
    return this.post<PolicyDocumentResponse, OrderSearchRequest>('/web/v1/order/report',request);
  }

  createOffer(orderNumber: string , packageId: string): Observable<any> {
    return this.get('/api/v1/axaInsurance/createOffer/' + orderNumber + '/' + packageId );
  }

  createOfferForceNonKps(orderNumber: string , packageId: string): Observable<any> {
    return this.get('/api/v1/axaInsurance/createOfferForceNonKps/' + orderNumber + '/' + packageId );
  }

  createPolicy(orderNumber:string ,packageId:string): Observable<any>{
    return this.get('/api/v1/axaInsurance/approveOffer/' + orderNumber + '/' + packageId );
  }

  callTY(orderNumber:string ,packageId:string): Observable<any>{
    return this.get('/api/v1/axaInsurance/callTY/' + orderNumber + '/' + packageId );
  }

  updateWsHist(request: UpdateHistRequest): Observable<any>{
    return this.put<any,UpdateHistRequest>(this.orderBasePath + '/hist', request);
  }

  cancelPolicy(policyNumber: String): Observable<any>{
    return this.post<any, PostIptalResponse>( '/web/v1/policies/' + policyNumber + '/cancel', null);
  }

  photoAction( request: ApprovePhotoRequest ): Observable<any>{
    return this.post<any, ApprovePhotoRequest>( this.orderBasePath + '/screen-damage/approvePhoto', request);
  }

  imeiApprove(  orderLineId: string ): Observable<any>{
    return this.get(this.orderBasePath + '/screen-damage/approveImei/' + orderLineId);
  }

  dealerList(): Observable<any> {
    return this.get('/web/v1/dealer-list' );
  }

  getDealerList( dealerCode: string ): Observable<any> {
    return this.get('/web/v1/dealer-list/' + dealerCode );
  }

  getSozlesmeSpecs( policyNo: string): Observable<any> {
    return this.get('web/v1/policy/sozlesme/' + policyNo );
  }
  
  changeOrder(request: ChangePolicyRequest): Observable<any>{
    return this.post<any, ChangePolicyRequest>( '/web/v1/changePolicy', request);
  }

  getReportList(): Observable<ReporDefinitionResponse[]> {
    return this.get<ReporDefinitionResponse[]>(this.reportBasePath + '/list' );
  }

  getReportInfo(reportId ): Observable<ReporDefinitionResponse> {
    return this.get<ReporDefinitionResponse>(this.reportBasePath + '/report/' + reportId);
  }

  callReport( request:ReportRequest ):Observable<any>{
    return this.post<any ,ReportRequest >( this.reportBasePath + '/callAsync',request);
  }

  /*
  Claim servisleri can be seperated
  */
  getClaims( orderId:string, packageId:string , salesChannel:string ): Observable<any>{
    return this.get(this.claimBasePath+"/"+orderId+"/"+packageId+"/"+salesChannel );
  }

  findClaimId( claimNo:string): Observable<any>{
    return this.get(this.claimBasePath + "/find-claim/" + claimNo); 
  }

  saveClaims( request:ClaimRequet ): Observable<any>{
    return this.post<any, ClaimRequet>(this.claimBasePath+"/",request );
  }

  deleteClaims( request:ClaimRequet ): Observable<any>{
    return this.post<any, ClaimRequet>(this.claimBasePath+"/delete",request );
  }

  getTYClaimInfo( tyReference:string ): Observable<any>{
    return this.get(this.claimBasePath+"/ty/"+tyReference );
  }

  getCSClaimInfo( csReference:string ): Observable<any>{
    return this.get(this.claimBasePath+"/cs/"+csReference );
  }

  tyApprove( request:ClaimRequet ): Observable<any>{
    return this.post<any, ClaimRequet>(this.claimBasePath+"/ty/approve",request );
  }

  tyReject( request:ClaimRequet ): Observable<any>{
    return this.post<any, ClaimRequet>(this.claimBasePath+"/ty/reject",request );
  }

  tyCallback( request:ClaimRequet ): Observable<any>{
    return this.post<any, ClaimRequet>(this.claimBasePath+"/ty/callback",request );
  }

  repairTypes(productGroupCode:string, mainType:string): Observable<any> {
    return this.get<any>(this.claimBasePath + '/repair-types/' + productGroupCode + "/" + mainType);
  }

  getProductGroups(mainType:string): Observable<string[]> {
    return this.get<string[]>(this.claimBasePath + '/product-groups/' + mainType);
  }
  
  getRepairTypes(productGroupCode: string): Observable<string[]> {
    return this.get<string[]>(this.claimBasePath + '/repair-types?productGroupCode=' + productGroupCode);
  }  

  saveRepairDetails(payload: any): Observable<any> {
    return this.post<any, any>(this.claimBasePath + '/repair-detail/save', payload);
  }  

  getRepairDetails(claimNo: string): Observable<any> {
    return this.get<any>(this.claimBasePath + '/repair-details/list/' + claimNo);
  }
  
  deleteRepair(id: number): Observable<any> {
    return this.get<any>(this.claimBasePath + '/repair-details/delete/' + id);
  }

  approveDamage(claimNo:string): Observable<any> {
    return this.get<any>(this.claimBasePath + '/approve-damage/' + claimNo);
  }

  rejectDamage(claimNo:string, reason:number): Observable<any> {
    return this.get<any>(this.claimBasePath + '/reject-damage/' + claimNo + '/' + reason);
  }

  cancelCekIptal(iban: string, dosyaNo: string, ekOdeme: number): Observable<any> {
    const body = { iban: iban, dosyaNo: dosyaNo, ekOdeme: ekOdeme};
    return this.post(this.claimBasePath + '/cancelCheck', body);
  }

  saveDoc(request: FileUploadRequest){
    return this.post(this.claimBasePath + '/document/save' , request);
  }

  getDocsWithRefTable(refId, refTable): Observable<any>  {
    return this.get(this.claimBasePath + '/document/reference/' + refId + "/" + refTable);
  }

  deleteDocument(refId): Observable<any>  {
    return this.delete(this.claimBasePath + '/document/delete/' + refId);
  }

  downloadDoc(documentId: number): Observable<Blob> {
    return this.http.get(  this._baseUrl + this.claimBasePath + "/document/download/" + documentId, {responseType: 'blob'});
  }

  /** Raporlar sayfasındaki tablo için gerekli servislerin başlangıcı */
  getRunningReportList(): Observable<any> {
    return this.get<any>('/web/v1/report/report/result/' + 'list');
  }

  getReportResult(id): Observable<any> {
    return this.get<any>('/web/v1/report/report/result/' + id);
  }

  stopReport(id): Observable<any> {
    return this.delete<any>('/web/v1/report/report/result/' + id);
  }
  /** Raporlar sayfasındaki tablo için gerekli servislerin bitişi */
  getTeknosaPremium(taxNumber: string): Observable<any> {
    return this.get<any>( '/web/v1/policy/sozlesme/' + taxNumber);
  }

}
